import style from "./ande_visuals.module.css"
import React, {useRef, useState} from "react";
import * as Data from "./get_section_content";
import {GetAssetID} from "./get_section_content";

const path_to_sketches = "./ande"

// default position for frame
const defaultX = 0; // as %
const defaultY = 0; // as %
const defaultWidth = 100; // as vw
const defaultHeight = 100; // as vh

export function AndeVisuals({section}) {
    if (section !== Data.HOME) {
        // get path by section using asset id to match directory
        const path = `${path_to_sketches}/${GetAssetID(section)}/index.html`;

        return (
            <div id={"AndeVisuals"}>
                <div id={`${section}_visuals`}>
                    <IFrame src={path} rectum={GetRectBySection(section)}/>
                </div>
            </div>
        )
    } else return null;
}

// get frame position by section
function GetRectBySection(section) {
    const LEFT_POSITION = -28;
    const RIGHT_POSITION = 28;
    const FULL_WIDTH = 95;
    const FULL_HEIGHT = 60;

    switch (section) {
        case Data.HOME:
            return new Rectum(defaultX, defaultY, defaultWidth, defaultHeight);
        case Data.CANNIBALISM:
            return new Rectum(0, -5, 40, 60);
        case Data.CANNIBALISM_2:
            return new Rectum(LEFT_POSITION, defaultY, 40, 60);
        case Data.MEIOSIS:
            return new Rectum(defaultX, defaultY, FULL_WIDTH, FULL_HEIGHT);
        case Data.MEIOSIS_2:
            return new Rectum(defaultX, defaultY, FULL_WIDTH, FULL_HEIGHT);
        case Data.RECOMBINATORIAL_REPAIR:
            return new Rectum(RIGHT_POSITION, -15, 50, 70);
        case Data.RECOMBINATORIAL_REPAIR_2:
            return new Rectum(5, -8, 50, 80);
        case Data.BINARY_FISSION:
            return new Rectum(defaultX, defaultY, FULL_WIDTH, FULL_HEIGHT);
        case Data.BINARY_FISSION_2:
            return new Rectum(defaultX, defaultY, FULL_WIDTH, FULL_HEIGHT);
        case Data.CONJUGATION:
            return new Rectum(defaultX, defaultY, FULL_WIDTH, FULL_HEIGHT);
        case Data.CONJUGATION_2:
            return new Rectum(defaultX, defaultY, FULL_WIDTH, FULL_HEIGHT);
        case Data.MITOSIS:
            return new Rectum(RIGHT_POSITION, defaultY, 27, 52.5);
        case Data.MITOSIS_2:
            return new Rectum(defaultX, defaultY, FULL_WIDTH, FULL_HEIGHT);
        case Data.SPORE_SHOOTING:
            return new Rectum(defaultX, defaultY, 40, 60);
        case Data.SPORE_SHOOTING_2:
            return new Rectum(defaultX, defaultY, FULL_WIDTH, FULL_HEIGHT);
        case Data.SPECIALISED_TRANSDUCTION:
            return new Rectum(defaultX, defaultY, FULL_WIDTH, FULL_HEIGHT);
        case Data.SPECIALISED_TRANSDUCTION_2:
            return new Rectum(defaultX, defaultY, FULL_WIDTH, FULL_HEIGHT);
        case Data.BACTERIAL_TRANSFORMATION:
            return new Rectum(defaultX, defaultY, FULL_WIDTH, FULL_HEIGHT);
        case Data.BACTERIAL_TRANSFORMATION_2:
            return new Rectum(defaultX, defaultY, FULL_WIDTH, FULL_HEIGHT);
        default:
            return null;
    }
}

class Rectum {
    xPos;
    yPos;
    width;
    height;

    constructor(xPos, yPos, width, height) {
        this.xPos = xPos
        this.yPos = yPos
        this.width = width
        this.height = height
    }
}

// for showing the iframe of the visual indirectly
function IFrame({src, rectum}) {
    const [isValid, setIsValid] = useState(true);
    const frame = useRef(null);

    return (
        <div style={{textAlign: "center"}}>
            {isValid ?
                <iframe
                    ref={frame}
                    src={src}
                    style={{
                        position: "relative",
                        left: rectum ? `${rectum.xPos}vw` : `${defaultX}vw`,
                        top: rectum ? `${rectum.yPos}vh` : `${defaultY}vh`,
                        width: rectum ? `${rectum.width}vw` : `${defaultWidth}vw`,
                        height: rectum ? `${rectum.height}vh` : `${defaultHeight}vh`,
                    }}
                    scrolling={"no"}
                />
                :
                <p>❗ Error - invalid html file: {src}</p>
            }
        </div>
    )
}

